import Tienda from './Tienda'
export default Tienda
